import { render, staticRenderFns } from "./MyGroup.vue?vue&type=template&id=1d83aa79&scoped=true&"
import script from "./MyGroup.vue?vue&type=script&lang=js&"
export * from "./MyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83aa79",
  null
  
)

export default component.exports